import TabGroupSeguros from '@/components/molecules/TabGroupSeguros';
import { SeguroTabs } from '@/data/misc/seguros-tabs';

export default function MaoNaRodaPage() {
  return <TabGroupSeguros tab={SeguroTabs['mao-na-roda'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
